import gql from 'graphql-tag'
import { PaymentRecipientFragment } from '@/graphql/fragments/finance'

export const mutation = gql`
  ${PaymentRecipientFragment}
  mutation updatePaymentRecipient($id: Int!,$fields: finance_payment_recipient_set_input!) {
    record: update_finance_payment_recipient_by_pk(pk_columns: {id: $id}, _set: $fields) {
      ...PaymentRecipient
    }
  }
`

export default mutation
